import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { capitalize, Stack } from "@mui/material";
import { Link, useParams, useNavigate } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";
import PolarAreaChart from "../../Components/PolarChart/PolarChart.jsx";
import { getMindsetSum, categorizeMindset, getPercentileFromScore } from "../../globalFunctions";

import prevArrow from "../../Assets/Images/prev-arrow.svg";
import nextArrow from "../../Assets/Images/next-arrow.svg";

import testimonialImage from "../../Assets/Images/testimonial.png";
import scheduledImage from "../../Assets/Images/schedule-image.png";
import quotationImage from "../../Assets/Images/quotation.svg";
import TeamDashboard from "../../Assets/Images/sample-dash-team-desk.png";
import TeamDashboardMobile from "../../Assets/Images/sample-dash-team-mobi.png";
import IndividualDashboard from "../../Assets/Images/sample-dash-indi-desk.png";
import IndividualDashboardMobile from "../../Assets/Images/sample-dash-indi-mobi.png";

//assets
import logo1 from "../../Assets/Images/logo1.png";
import logo2 from "../../Assets/Images/logo2.png";
import logo3 from "../../Assets/Images/logo3.png";
import logo4 from "../../Assets/Images/logo4.png";
import logo5 from "../../Assets/Images/logo5.png"
import logo6 from "../../Assets/Images/logo6.png";
import logo7 from "../../Assets/Images/logo7.png";
import visionarylogo from '../../Assets/Images/VISIONARY.png';
import stratrgiclogo from '../../Assets/Images/STRATEGIC.png';
import performancelogo from '../../Assets/Images/PERFORMANCE.png';
import collaborativelogo from '../../Assets/Images/COLLABORATIVE.png';
import logo4lessthen from '../../Assets/Images/logo4lessthen.png';
import arrowDown from "../../Assets/Images/arrowdown.png";
import mindSet from "../../Assets/Images/MindSetImage.png";
import flowImage from "../../Assets/Images/flowImage.png";
import Leaf from "../../Assets/Images/leaf.svg";
import conditionalLogo from '../../Assets/Images/conditional.png'
import conditionalLogo2 from '../../Assets/Images/conditional_edit.png'
import FixedMindsetLogo from '../../Assets/Images/fixed-new.png'

import flow_HM from "../../Assets/Images/flowScoreIcons/H-M.png";
import flow_HS from "../../Assets/Images/flowScoreIcons/H-S.png";
import flow_HST from "../../Assets/Images/flowScoreIcons/H-ST.png";
import flow_MH from "../../Assets/Images/flowScoreIcons/M-H.png";
import flow_MS from "../../Assets/Images/flowScoreIcons/M-S.png";
import flow_MST from "../../Assets/Images/flowScoreIcons/M-ST.png";
import flow_SH from "../../Assets/Images/flowScoreIcons/S-H.png";
import flow_SM from "../../Assets/Images/flowScoreIcons/S-M.png";
import flow_SST from "../../Assets/Images/flowScoreIcons/S-ST.png";
import flow_STH from "../../Assets/Images/flowScoreIcons/ST-H.png";
import flow_STM from "../../Assets/Images/flowScoreIcons/ST-M.png";
import flow_STS from "../../Assets/Images/flowScoreIcons/ST-S.png";




import useWindowDimensions from "../../Hooks/useWindowDimensions";
import { sectionsText } from "../../globalFunctions";
import InviteInfo from "../../Components/InviteInfo/InviteInfo.jsx";
import Testimonial from "../../Components/Testimonial/Testimonial.jsx";
import ClickableCircularProgressBars from "../../Components/ClickableCircularProgressBars";
// import DonutChart from "../Components/DonutChart";
// import DonutChartAccordion from "../Components/DonutChartAccordion";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Switch,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Add, ArrowDownwardSharp, Remove } from "@mui/icons-material";
import CallInfo from "../../Components/CallInfo/CallInfo.jsx";
import Invite from "../Invite/Invite.jsx";
import StarterChart from "./StarterChart.jsx";

const CustomExpandIcon = () => {
  return (
    <Box
      sx={{
        ".Mui-expanded & > .collapsIconWrapper": {
          display: "none",
        },
        ".expandIconWrapper": {
          display: "none",
        },
        ".Mui-expanded & > .expandIconWrapper": {
          display: "block",
        },
      }}
    >
      <div className="expandIconWrapper">
        <Remove />
      </div>
      <div className="collapsIconWrapper">
        <Add />
      </div>
    </Box>
  );
};

const Results = (props) => {
  let navigate = useNavigate();
  const { id } = useParams();

  const { windowWidth } = useWindowDimensions();
  const [isLoading, setIsLoading] = useState(true);
  const [isMember, setIsMember] = useState(false);
  const [apiData, setApiData] = useState();
  const [name, setName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Starter");
  const [selectedCategoryIdx, setSelectedCategoryIdx] = useState(0);
  const [score, setScore] = useState(0);
  const [sections, setSections] = useState([]);
  const [subScore1, setSubScore1] = useState(0);
  const [subScore2, setSubScore2] = useState(0);
  const [subScore3, setSubScore3] = useState(0);
  const [subScore4, setSubScore4] = useState(0);
  const [subScore5, setSubScore5] = useState(0);
  const [subScores, setSubScores] = useState([0, 0, 0, 0, 0]);
  const [currentView, setCurrentView] = useState(0);
  const [firstName, setFirstName] = useState('');
  const [toggleIndividual, setToggleIndividual] = useState(1);
  const [largeScreen, setLargeScreen] = useState(true);
  const [highestStarter, setHighestStarter] = useState('')
  const [starterScore, setStarterScore] = useState(null)
  const [snapshotResult, setSnapshotResults] = useState([])
  const [starterLabel, setStarterLabel] = useState([])
  const [highestLeadershipStarter, setHighestLeadershipStarter] = useState('')
  const [leadershipScore, setLeadershipScore] = useState(null)
  const [leadershipSnapshotResults, setLeadershipSnapshotResults] = useState([])
  const [leadershipLabels, setLeadershipLabels] = useState([])
  const lsObj = JSON.parse(localStorage.getItem(`searchParams-${id}`))
  const [userName, setUserName] = useState(lsObj?.selfUserName)
  const [mostSelecTedStarter, setMostSelecTedStarter] = useState('')
  const [secondMostSelecTedStarter, setSecondMostSelecTedStarter] = useState('')
  const [flowContent, setFlowContent] = useState([]);
  const [variablsMapArray, setVariableMapArray] = useState()

  const [leader, setLeader] = useState(null);
  const [member, setMember] = useState(null);
  const [selfUserName, setSelfUserName] = useState(null)

  const [chartsData, setChartsData] = useState();
  const categories = ["Starter", "Flow", "Leadership", "Mindset"];
  const categories1 = [
    { name: "Starter", description: "Starter" },
    { name: "Flow", description: "Flow" },
    { name: "Leadership", description: "Leadership" },
    { name: "Mindset", description: "Mindset" },
  ];

  const capitalizeName = (name) => {
    if (!name) return null;
    return name
      .trim()
      .split(/\s+/)
      .map(
        word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(' ');
  };

  useEffect(() => {

    const storedData = JSON.parse(localStorage.getItem(`searchParams-${id}`)) || {};
    setLeader(capitalizeName(storedData.leader || null));
    setMember(capitalizeName(storedData.member || null));
    setSelfUserName(capitalizeName(storedData.selfUserName || null));

  }, []);

  // console.log(leader)
  // console.log(member)
  // console.log(selfUserName)


  const starterData = [6, 47, 28, 19];
  // const starterLabel = ['Mind', 'Strength', 'Soul', 'Heart'];
  const leadershipData = [14, 29, 22, 35];
  const leadershipLabel = [
    "Strategic",
    "Performance",
    "Visionary",
    "Collaborative",
  ];
  //[strenght, heart, soul, mind]

  useEffect(() => {
    // document.body.style.backgroundColor = "#292829";

    fetchResults();
  }, []);

  useEffect(() => {
    // basic check for API data reliability
    if (apiData?.score > 0 && apiData?.status === "success") {
      const score1 = apiData?.chart1Values?.find(
        (val) => val.name === apiData?.selected1Answer
      )?.y;
      const score2 = apiData?.chart2Values?.find(
        (val) => val.name === apiData?.selected2Answer
      )?.y;
      const score3 = apiData?.chart3Values?.find(
        (val) => val.name === apiData?.selected3Answer
      )?.y;
      const score4 = apiData?.chart4Values?.find(
        (val) => val.name === apiData?.selected4Answer
      )?.y;
      const score5 = apiData?.chart5Values?.find(
        (val) => val.name === apiData?.selected5Answer
      )?.y;

      setChartsData([
        {
          title: "The community around us is aware of our mission.",
          order: 1,
          values: apiData?.chart1Values,
          answer: { name: apiData?.selected1Answer, y: score1 },
        },
        {
          title:
            "How many engagement opportunities did you host in the past year open to the larger community?",
          order: 2,
          values: apiData?.chart2Values,
          answer: { name: apiData?.selected2Answer, y: score2 },
        },
        {
          title:
            "Throughout last year, how many community members participated in these engagement opportunities?",
          order: 3,
          values: apiData?.chart3Values,
          answer: { name: apiData?.selected3Answer, y: score3 },
        },
        {
          title:
            "Over time, our church's engagement with our community has been...",
          order: 4,
          values: apiData?.chart4Values,
          answer: { name: apiData?.selected4Answer, y: score4 },
        },
        {
          title:
            "Our community frequently utilizes our church's building facilities and programs.",
          order: 5,
          values: apiData?.chart5Values,
          answer: { name: apiData?.selected5Answer, y: score5 },
        },
      ]);
    }
  }, [apiData]);

  useEffect(() => {
    if (windowWidth > 830) {
      setLargeScreen(true);
    } else {
      setLargeScreen(false);
    }
  }, [windowWidth]);

  useEffect(() => {
    document.body.style.background = "#165470";
  }, []);

  // console.log("chartsData", chartsData);

  // to animate subScores on results page
  useEffect(() => {
    // this settimeout is causing donutcharts selected pie enlargement to disappear so commented it out
    // const timer = setTimeout(() => {
    //   setSubScores([subScore1, subScore2, subScore3, subScore4, subScore5]);
    // }, 250);
    // return () => {
    //   clearTimeout(timer);
    // };

    setSubScores([subScore1, subScore2, subScore3, subScore4, subScore5]);
  }, [subScore1, subScore2, subScore3, subScore4, subScore5]);

  const fetchResults = () => {
    // fetch(process.env.REACT_APP_API_URI + "/v1/assessment/" + id, {
    fetch(
      process.env.REACT_APP_API_URI + "/v3/user/assessment/" + id + "/results",
      {
        // fetch(process.env.REACT_APP_API_URI + "/v3/user/assessment/" + id + "/results", {
        method: "GET",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          // console.log("data is here")
          // console.log(data);

          const variableMap = data?.variables?.reduce((acc, el) => {
            acc[el.variable] = el.score;
            return acc;
          }, {});

          // console.log("variableMap", variableMap)
          setVariableMapArray(variableMap)

          setApiData(data);
          setName(data.fullName);
          setScore(data.score);
          setSections(data.sections);
          setSubScore1(data.subScore1);
          setSubScore2(data.subScore2);
          setSubScore3(data.subScore3);
          setSubScore4(data.subScore4);
          setSubScore5(data.subScore5);
          setIsMember(data.isMember);
          const firstNameRaw = data.fullName.split(' ')[0];
          const firstName = firstNameRaw === firstNameRaw.toUpperCase() ? firstNameRaw : firstNameRaw.charAt(0).toUpperCase() + firstNameRaw.slice(1).toLowerCase();
          setFirstName(firstName);
          // console.log(data);

          setIsLoading(false);
        } else {
          // setOpenSnackbar(true);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch results...", err);
      });
  };

  // const showTitleText = () => {
  //   if (score > 0 && score <= 50) {
  //     return <h1><span className="user-name">{name}</span>, your ChMS is Sub-optimal</h1>
  //   } else if (score > 50 && score <= 80) {
  //     return <h1><span className="user-name">{name}</span>, your ChMS is Adequate</h1>
  //   } else if (score > 80) {
  //     return <h1><span className="user-name">{name}</span>, your ChMS is Perfect</h1>
  //   }
  // };

  const sectionsAndSubScores = sections?.map((sec, idx) => ({
    section: sec.section,
    score: subScores[idx],
  }));
  // remove the last Feedback section from Results and Dashboard
  // sectionsAndSubScores.pop();
  // console.log("sectionsAndSubScores", sectionsAndSubScores);

  const sortedSectionsAndSubScores = [...sectionsAndSubScores]?.sort(
    (a, b) => a.score - b.score
  );
  // console.log("sortedSectionsAndSubScores", sortedSectionsAndSubScores);

  // get the object with the highest score
  let highestScoreObject =
    sortedSectionsAndSubScores?.[sortedSectionsAndSubScores?.length - 1];

  // if there are duplicate highest scores, find the first occurrence
  if (
    highestScoreObject?.score ===
    sortedSectionsAndSubScores[sortedSectionsAndSubScores?.length - 2]?.score
  ) {
    let currentIndex = sortedSectionsAndSubScores?.length - 2;
    while (
      currentIndex >= 0 &&
      sortedSectionsAndSubScores?.[currentIndex]?.score ===
      highestScoreObject.score
    ) {
      highestScoreObject = sortedSectionsAndSubScores[currentIndex];
      currentIndex--;
    }
  }

  // console.log("sortedSectionsAndSubScores[sortedSectionsAndSubScores?.length - 1]", sortedSectionsAndSubScores[sortedSectionsAndSubScores?.length - 1]);
  // console.log("highestScoreObject", highestScoreObject);
  const toggleTeamIndividual = (tab) => {
    if (tab == 1) {
      setCurrentView(0);
      setToggleIndividual(1);
    } else {
      setCurrentView(1);
      setToggleIndividual(0);
    }
  };
  const toggleIndividualChange = (e) => {
    // setToggleSection(!e.target.checked);
    if (e.target.checked) {
      toggleTeamIndividual(0);
    } else {
      toggleTeamIndividual(1);
    }
  };

  const showTitleText = () => {
    if (score >= 0 && score <= 50) {
      return (
        <h1>
          {name}, it seems like there's significant scope to improve your impact
          in your marriage ministry!
        </h1>
      );
    } else if (score > 50 && score <= 80) {
      return (
        <h1>
          {name}, you're ready for greater impact in your marriage ministry!
        </h1>
      );
    } else if (score > 80) {
      return (
        <h1>
          {name}, your current efforts seem to be elevating impact in your
          marriage ministry!
        </h1>
      );
    }
  };

  const showScoreText = () => {
    const section =
      sectionsText?.[sortedSectionsAndSubScores[0]?.section?.toLowerCase()];
    const allScoresSame = sortedSectionsAndSubScores?.every(
      (obj) => obj.score === sortedSectionsAndSubScores?.[0]?.score
    );

    if (allScoresSame) {
      return (
        <div className="result-text">
          <p style={{ margin: "10px auto 30px" }}>
            We're glad to see you're maintaining a balanced focus across all
            fronts of your community engagement strategy.
          </p>
          <p style={{ margin: "10px auto 5px" }}>
            Here are some quick tips to elevate engagement through all areas and
            maximize your Kingdom impact:
          </p>
          <div style={{ margin: "5px auto 10px 10px" }}>
            {sectionsText?.sameScores?.map((text, idx) => (
              <p style={{ margin: "2px auto" }}>
                {idx + 1}.&nbsp;&nbsp;{text}
              </p>
            ))}
          </div>
        </div>
      );
    } else
      return (
        <div className="result-text">
          <p style={{ margin: "10px auto 30px" }}>
            Keep up the good work on the{" "}
            <span style={{ fontWeight: "700" }}>
              {highestScoreObject?.section?.toLowerCase()}
            </span>{" "}
            front and pay special attention to{" "}
            <span style={{ fontWeight: "700" }}>
              {sortedSectionsAndSubScores[0]?.section?.toLowerCase()}
            </span>
            .
          </p>
          <p style={{ margin: "10px auto 5px" }}>Here are some quick tips:</p>
          <div style={{ margin: "5px auto 10px 10px" }}>
            {section?.map((text, idx) => (
              <p style={{ margin: "2px auto" }}>
                {idx + 1}.&nbsp;&nbsp;{text}
              </p>
            ))}
          </div>
        </div>
      );
    // if (score > 0 && score <= 50) {
    //   return <div className="result-text">
    //     <p></p>
    //   </div>
    // } else if (score > 50 && score <= 80) {
    //   return <div className="result-text">
    //     <p></p>
    //   </div>
    // } else if (score > 80) {
    //   return <div className="result-text">
    //     <p></p>
    //   </div>
    // }
  };

  const showProgressBarText = (scoreValue) => {
    if (scoreValue >= 95) {
      return "Enjoying health";
    } else if (scoreValue >= 80 && scoreValue < 95) {
      return "Improving health";
    } else if (scoreValue >= 70 && scoreValue < 80) {
      return "Pursuing health";
    } else if (scoreValue < 70) {
      return "Battling unhealthiness";
    }
  };

  const handleSetCategoryLeft = () => {
    const currentIndex = categories.indexOf(selectedCategory);
    const newIndex = (currentIndex - 1 + categories.length) % categories.length;

    setSelectedCategory(categories[newIndex]);
    setSelectedCategoryIdx(newIndex);
  };
  const handleSetCategoryRight = () => {
    const currentIndex = categories.indexOf(selectedCategory);
    const newIndex = (currentIndex + 1 + categories.length) % categories.length;

    setSelectedCategory(categories[newIndex]);
    setSelectedCategoryIdx(newIndex);
  };

  const showDashboard = () => {
    return (
      <>
        <div className="dashboard-heading">
          <div className="line"></div>
          <h1>SAMPLE DASHBOARD</h1>
        </div>
        {/* <h1>SAMPLE DASHBOARD</h1> */}
        <div className="individual-group">
          <button
            onClick={() => setCurrentView(0)}
            className={currentView == 0 ? "active left" : "left"}
          >
            TEAM
          </button>
          <button
            onClick={() => setCurrentView(1)}
            className={currentView == 1 ? "active right" : "right"}
          >
            INDIVIDUAL
          </button>
        </div>
        <div className="toggle-individual-group">
          <div className={currentView == 0 ? "active left" : "left"}>TEAM</div>
          <Switch
            checked={!toggleIndividual}
            onChange={toggleIndividualChange}
            inputProps={{ "aria-label": "controlled" }}
          />
          <div className={currentView == 1 ? "active right" : "right"}>
            INDIVIDUAL
          </div>
        </div>
        <div className="results-dashboard-container">
          <img
            src={
              currentView === 0
                ? largeScreen
                  ? TeamDashboard
                  : TeamDashboardMobile
                : largeScreen
                  ? IndividualDashboard
                  : IndividualDashboardMobile
            }
            alt=""
          />
        </div>
      </>
    );
  };

  const showInvite = () => {
    if (isMember) return null;
    else if (props?.showInvite === false) return null;
    else return <InviteInfo />;
  };

  const showTeamMember = () => {
    if (isMember) {
      return (
        <div className="team-container">
          <h3>Thank you for taking this assessment!</h3>
          Please get in touch with your leader for the next step.
          <br />
          <br />
        </div>
      );
    } else {
      return null;
    }
  };

  const showTestimonial = () => {
    if (!isMember) {
      return <Testimonial />;
    } else {
      // return null;
      return <Testimonial />;
    }
  };

  const showCallInfo = () => {
    if (!isMember) {
      return <CallInfo />;
    }
  };

  const getLeftMargin = () => {
    if (windowWidth <= 830) {
      if (score > 96 && score < 100) {
        return { left: 96.5 + "%" };
      } else if (score >= 100) {
        return { left: 97.5 + "%" };
      } else if (score > 0 && score < 3) {
        return { left: 2.5 + "%" };
      } else if (score <= 0) {
        return { left: 1.5 + "%" };
      } else {
        return { left: Math.round(score) + "%" };
      }
    } else {
      return { left: Math.round(score) + "%" };
    }
  };

  const getBarTextLeft = (score) => {
    if (window.innerWidth < 650 && score > 80) {
      return { left: "-170px" };
    }
    return { left: "-100px" };
  };

  const showSchedule = () => {
    if (isMember) {
      return null;
    } else {
      return (
        <div className="schedule-container">
          <div className="avatar">
            <img src={scheduledImage} />
          </div>
          <h3>Schedule a call with Kim</h3>
          <p>
            Ready to optimize your board for fundraising or craft and execute an
            effective annual giving or capital campaign focused on Biblical
            generosity?
          </p>
          <p>
            Talk with Kim to learn how your Christian school's fundraising can
            become truly transformative.
          </p>
          <div className="cta-btn">
            <a href="https://meetings.hubspot.com/kim-jennings" target="_blank">
              <Button>TALK TO KIM</Button>
            </a>
          </div>
        </div>
      );
    }
  };

  const showLegacyInvite = () => {
    if (isMember) {
      return null;
    } else {
      return (
        <div className="invite-legacy-container">
          <div className="invite-legacy">
            <h1>Here are your next steps:</h1>
            <div className="steps">
              <ol>
                <li>Invite your leadership team to take this test.</li>
                <li>
                  Unlock your team's individual responses and team scores.*
                </li>
              </ol>
            </div>
            {/* <p>Get your team to take this test and see if they think your church is guest ready.</p> */}
            <div className="cta-btn">
              <Link to={"/invite-team/" + id} target="_blank">
                <Button>Invite My Team</Button>
              </Link>
            </div>
            <p>*Scroll down to see what your dashboard may look like.</p>
          </div>
        </div>
      );
    }
  };

  const leadershipPairs = [
    { round1: "col_round1_m", round2: "col_round2_m" },
    { round1: "strat_round1_m", round2: "strat_round2_m" },
    { round1: "per_round1_m", round2: "per_round2_m" },
    { round1: "vis_round1_m", round2: "vis_round2_m" }
  ]

  const pairs = [
    { round1: "heart_round1_m", round2: "heart_round2_m" },
    { round1: "soul_round1_m", round2: "soul_round2_m" },
    { round1: "str_round1_m", round2: "str_round2_m" },
    { round1: "mind_round1_m", round2: "mind_round2_m" }
  ];

  const findMaximum = (items) => items.reduce((max, current) => {
    return current.value > max.value ? current : max;
  }, items[0]);

  useEffect(() => {
    let highestScore = -Infinity;
    let highestVariable = "";
    let results = [];
    let labelsArray = [];

    if (variablsMapArray) {
      // console.log(variablsMapArray);
      const heart_r1_m = variablsMapArray["heart_round1_m"] || 0;
      const soul_r1_m = variablsMapArray["soul_round1_m"] || 0;
      const mind_r1_m = variablsMapArray["mind_round1_m"] || 0;
      const strength_r1_m = variablsMapArray["str_round1_m"] || 0;
      const heart_r2_m = variablsMapArray["heart_round2_m"] || 0;
      const soul_r2_m = variablsMapArray["soul_round2_m"] || 0;
      const mind_r2_m = variablsMapArray["mind_round2_m"] || 0;
      const strength_r2_m = variablsMapArray["str_round2_m"] || 0;
      const heart_r1_l = variablsMapArray["heart_round1_l"] || 0;
      const soul_r1_l = variablsMapArray["soul_round1_l"] || 0;
      const mind_r1_l = variablsMapArray["mind_round1_l"] || 0;
      const strength_r1_l = variablsMapArray["str_round1_l"] || 0;
      const heart_r2_l = variablsMapArray["heart_round2_l"] || 0;
      const soul_r2_l = variablsMapArray["soul_round2_l"] || 0;
      const mind_r2_l = variablsMapArray["mind_round2_l"] || 0;
      const strength_r2_l = variablsMapArray["str_round2_l"] || 0;

      let most_score = Math.max(heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m)
      let second_most_score = Math.max(heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m) / 2
      let least_score = Math.max(heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l)
      let second_least_score = Math.max(heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l) / 2

      if (least_score >= second_least_score) {
        least_score = second_least_score - 1;
      }
      const total = most_score + second_most_score + least_score + second_least_score;


      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100;

      const labels_arr = ["heart", "soul", "mind", "strength"];
      const mostValues = [heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m];
      const secondMostValues = [heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m];
      const leastValues = [heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l];
      const secondLeastValues = [heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l];
      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);
      const getLabel = (values, maxValue, type) => {
        const hasDuplicates = values.filter(v => v === maxValue).length > 1;

        if (hasDuplicates && type === "2nd_least") {
          const firstIndex = values.indexOf(maxValue);
          const secondIndex = values.findIndex((el, index) => el === maxValue && index !== firstIndex);

          return labels_arr[secondIndex];
        }

        return labels_arr[values.indexOf(maxValue)]; // Default case
      };
      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label, "2nd_least");

      const getPercentageOrder = (label) => {
        if (label === most_label?.toLowerCase()) return most_per;
        if (label === second_most_label?.toLowerCase()) return second_most_per;
        if (label === least_label?.toLowerCase()) return least_per;
        if (label === second_least_label?.toLowerCase()) return second_least_per;
        return 0;
      };

      // order should be most > second most > least > second least
      // results = [getPercentageOrder("mind"), getPercentageOrder("soul"), getPercentageOrder("strength"), getPercentageOrder("heart")] // label order = 'mind', 'soul', 'strength', 'heart'
      results = [getPercentageOrder("strength"), getPercentageOrder("heart"), getPercentageOrder("soul"), getPercentageOrder("mind")] // label order = 'mind', 'soul', 'strength', 'heart'

      // labelsArray = [...labelsArray, ...labels];
      // labelsArray = [least_label, second_least_label, second_most_label, most_label];
      labelsArray = ['mind', 'soul', 'strength', 'heart'];

      // console.log('highestVariable', highestVariable)
      // console.log("pie chart results original", most_score, second_most_score, least_score, second_least_score);
      console.log("pie chart results", results);
      // console.log("pie chart labelsArray", labelsArray);
      // console.log("newStarterAverages self", results)

      setHighestStarter(most_label);
      setStarterScore(most_per);
      setSnapshotResults(results);
      setStarterLabel(labelsArray);
      getMostAndSecondMostVaribale(apiData)

    }

  }, [apiData, variablsMapArray]);


  const getMostAndSecondMostVaribale = (apiData) => {
    if (apiData?.variables?.length > 0) {
      const extractCoreVariable = (variable) =>
        variable?.split("_")[0];

      const highestRound1Variable = pairs
        ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round1))
        ?.filter(Boolean)
        ?.reduce((highest, current) => (current?.score > highest?.score ? current : highest), { score: -Infinity });

      const highestRound2Variable = pairs
        ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round2))
        ?.filter(Boolean)
        ?.reduce((highest, current) => (current?.score > highest?.score ? current : highest), { score: -Infinity });

      const coreRound1 = extractCoreVariable(highestRound1Variable?.variable);
      const coreRound2 = extractCoreVariable(highestRound2Variable?.variable);

      if (coreRound1 === coreRound2) {
        const secondHighestRound1Variable = pairs
          ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round1))
          ?.filter(Boolean)
          ?.sort((a, b) => b?.score - a?.score) // Sort by score
          ?.find((v) => v?.variable !== highestRound1Variable?.variable); // Find second highest

        setMostSelecTedStarter(highestRound1Variable?.variable || null);
        setSecondMostSelecTedStarter(secondHighestRound1Variable?.variable || null);
      } else {
        setMostSelecTedStarter(highestRound1Variable?.variable || null);
        setSecondMostSelecTedStarter(highestRound2Variable?.variable || null);
      }
    }
  };




  useEffect(() => {
    // let highestLeadershipScore = -Infinity;
    // let highestLeadershipVariable = "";
    // let leadershipResults = [];
    // let leadershipLabelsArray = [];
    // console.log(apiData);
    // console.log(leadershipPairs);
    // leadershipPairs?.forEach(pair => {
    //   const round1Obj = apiData?.variables.find(v => v.variable === pair.round1);
    //   const round2Obj = apiData?.variables.find(v => v.variable === pair.round2);
    //   if (round1Obj && round2Obj) {
    //     const snapshotResult = (( round2Obj?.score + round1Obj?.score ) / 70) * 100;
    //     leadershipResults.push(snapshotResult);

    //     // Map round2 label to the desired label
    //     const rawLabel = pair?.round2.split('_')[0];
    //     const mappedLabel = {
    //       vis: "Visionary",
    //       col: "Collaborative",
    //       strat: "Strategic",
    //       per: "Performance"
    //     }[rawLabel] || rawLabel;

    //     leadershipLabelsArray.push(mappedLabel);

    //     // if (snapshotResult > highestLeadershipScore) {
    //     //   highestLeadershipScore = snapshotResult;
    //     //   highestLeadershipVariable = pair.round2;
    //     // }
    //   }
    // });

    // console.log('highestLeadershipVariable', highestLeadershipVariable)
    // setHighestLeadershipStarter(highestLeadershipVariable);
    // setLeadershipScore(highestLeadershipScore);
    // setLeadershipSnapshotResults(leadershipResults);
    // setLeadershipLabels(leadershipLabelsArray);

    let highestScore = -Infinity;
    let highestVariable = "";
    let results = [];
    let labelsArray = [];

    if (variablsMapArray) {
      // console.log(variablsMapArray);
      const performance_r1_m = variablsMapArray["per_round1_m"] || 0;
      const strategic_r1_m = variablsMapArray["strat_round1_m"] || 0;
      const visionary_r1_m = variablsMapArray["vis_round1_m"] || 0;
      const collaborative_r1_m = variablsMapArray["col_round1_m"] || 0;

      const performance_r2_m = variablsMapArray["per_round2_m"] || 0;
      const strategic_r2_m = variablsMapArray["strat_round2_m"] || 0;
      const visionary_r2_m = variablsMapArray["vis_round2_m"] || 0;
      const collaborative_r2_m = variablsMapArray["col_round2_m"] || 0;

      const performance_r1_l = variablsMapArray["per_round1_l"] || 0;
      const strategic_r1_l = variablsMapArray["strat_round1_l"] || 0;
      const visionary_r1_l = variablsMapArray["vis_round1_l"] || 0;
      const collaborative_r1_l = variablsMapArray["col_round1_l"] || 0;

      const performance_r2_l = variablsMapArray["per_round2_l"] || 0;
      const strategic_r2_l = variablsMapArray["strat_round2_l"] || 0;
      const visionary_r2_l = variablsMapArray["vis_round2_l"] || 0;
      const collaborative_r2_l = variablsMapArray["col_round2_l"] || 0;


      const collaborative_highest = Math.max(collaborative_r1_m, collaborative_r2_m, collaborative_r1_l, collaborative_r2_l);
      const strategic_highest = Math.max(strategic_r1_m, strategic_r2_m, strategic_r1_l, strategic_r2_l);
      const performance_highest = Math.max(performance_r1_m, performance_r2_m, performance_r1_l, performance_r2_l);
      const visionary_highest = Math.max(visionary_r1_m, visionary_r2_m, visionary_r1_l, visionary_r2_l);


      let most_score = Math.max(performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m)
      let second_most_score = Math.max(performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m) / 2
      let least_score = Math.max(performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l)
      let second_least_score = Math.max(performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l) / 2

      if (least_score >= second_least_score) {
        least_score = (second_least_score - 1)
      }

      const total = most_score + second_most_score + least_score + second_least_score;

      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score / total) * 100

      // console.log("scores-", most_score, second_most_score, least_score, second_least_score)
      // console.log("scores-per", most_per, second_most_per, least_score, second_least_per)

      let testingVarsM2Pair = [{ "name": "collaborative", "score": collaborative_highest }, { "name": "strategic", "score": strategic_highest }, { "name": "performance", "score": performance_highest }, { "name": "visionary", "score": visionary_highest }];

      highestVariable = testingVarsM2Pair.reduce((max, current) =>
        current.score > max.score ? current : max, { name: "", score: -Infinity }
      );

      // console.log(highestVariable);

      let scores = testingVarsM2Pair.map(item => item.score);
      results = [...results, ...scores];

      let labels = testingVarsM2Pair.map(item => item.name);
      labelsArray = [...labelsArray, ...labels];

      leadershipPairs?.forEach(pair => {
        const round1Obj = apiData?.variables.find(v => v.variable === pair.round1);
        const round2Obj = apiData?.variables.find(v => v.variable === pair.round2);
        // console.log("apiData", apiData)

        // console.log("pie chart round1Obj", round1Obj)
        // console.log("pie chart round2Obj", round2Obj)
        if (round1Obj && round2Obj) {
          const snapshotResult = round1Obj.score
          results.push(snapshotResult);
          let label = pair?.round1.split('_')[0];
          if (label === 'col') {
            label = 'collaborative'
          }
          if (label === 'vis') {
            label = 'visionary'
          }
          if (label === 'strat') {
            label = 'strategic'
          }
          if (label === 'per') {
            label = 'performance'
          }
          labelsArray.push(label);

          // if (snapshotResult > highestScore) {
          //   highestScore = snapshotResult;
          //   highestVariable = pair?.round1;
          // }
        }
      });

      const labels_arr = ["performance", "strategic", "visionary", "collaborative"];


      const mostValues = [performance_r1_m, strategic_r1_m, visionary_r1_m, collaborative_r1_m];
      const secondMostValues = [performance_r2_m, strategic_r2_m, visionary_r2_m, collaborative_r2_m];
      const leastValues = [performance_r1_l, strategic_r1_l, visionary_r1_l, collaborative_r1_l];
      const secondLeastValues = [performance_r2_l, strategic_r2_l, visionary_r2_l, collaborative_r2_l];

      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);

      const getLabel = (values, maxValue, type) => {
        const hasDuplicates = values.filter(v => v === maxValue).length > 1;

        if (hasDuplicates && type === "2nd_least") {
          const firstIndex = values.indexOf(maxValue);
          const secondIndex = values.findIndex((el, index) => el == maxValue && index !== firstIndex);

          return labels_arr[secondIndex];
        }

        return labels_arr[values.indexOf(maxValue)]; // Default case
      };
      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label, "2nd_least");


      const getPercentageOrder = (label) => {

        if (label == most_label?.toLowerCase()) {
          return most_per;
        }
        if (label == second_most_label?.toLowerCase()) {
          return second_most_per;
        }
        if (label == least_label?.toLowerCase()) {
          return least_per;
        }
        if (label == second_least_label?.toLowerCase()) {
          return second_least_per;
        }

        return 0
      }


      // results = [ getPercentageOrder("performance"),  getPercentageOrder("visionary") ,  getPercentageOrder("strategic") ,  getPercentageOrder("collaborative") ] // label order = 'performance', 'strategic', 'visionary', 'collaborative'
      results = [getPercentageOrder("performance"), getPercentageOrder("collaborative"), getPercentageOrder("visionary"), getPercentageOrder("strategic")] // label order = 'performance', 'collaborative', 'visionary', 'strategic'


      // console.log('highestVariable', highestVariable)
      // console.log("pie chart results", results);
      // console.log("pie chart labelsArray", labelsArray);

      setHighestLeadershipStarter(most_label);
      setLeadershipSnapshotResults(results);
      // setLeadershipLabels(["collaborative" , "strategic" , "performance", "visionary",  ]);
      setLeadershipLabels(["strategic", "visionary", "performance", "collaborative",]);
      getMostAndSecondMostVaribale(apiData)

    }
  }, [apiData, variablsMapArray, selectedCategory]);

  // console.log("snapshotResult", snapshotResult)
  // console.log("labels", starterLabel)
  // console.log("leadesrhipLabels", leadershipLabels)
  // console.log("leadershipSnapshotResults", leadershipSnapshotResults)

  const getSubheading = () => {
    // console.log('highestStarter', highestStarter);
    // const namePrefix = firstName ? `${firstName}, you` : 'You';

    if (highestStarter.includes('heart')) return `You show up as a Heart Starter.`;
    if (highestStarter.includes('str')) return `You show up as a Strength Starter.`;
    if (highestStarter.includes('soul')) return `You show up as a Soul Starter.`;
    if (highestStarter.includes('mind')) return `You show up as a Mind Starter.`;

    return '';
  };

  const getStarterLogo = () => {
    if (highestStarter?.includes("heart")) return logo1;
    if (highestStarter?.includes("str")) return logo5;
    if (highestStarter?.includes("soul")) return logo7;
    if (highestStarter?.includes("mind")) return logo6;
    else return logo1;
  }

  const getBottomHeading = () => {
    if (highestStarter.includes('heart')) return { text: 'Heart Starter.', color: '#B6111F' }
    if (highestStarter.includes('str')) return { text: 'Strength Starter.', color: '#C99212' }
    if (highestStarter.includes('soul')) return { text: 'Soul Starter.', color: '#00577D' }
    if (highestStarter.includes('mind')) return { text: 'Mind Starter.', color: '#667F96' }
    return { text: '', color: '' };
  }

  const { text, color } = getBottomHeading();


  const getSubheadingInfo = () => {
    // console.log('highestStarter', highestStarter);
    if (highestStarter.includes('heart')) return 'Heart Starters ignite deep connections and inspire collaboration by leading with empathy and passion.';
    if (highestStarter.includes('str')) return 'Strength Starters transform ideas into action with energy and efficiency to serve a greater purpose.';
    if (highestStarter.includes('soul')) return 'Soul Starters captivate with vision and creativity, using deep meaning and storytelling to inspire and guide.';
    if (highestStarter.includes('mind')) return 'Mind Starters excel at transforming complexity into clarity with strategic insight and analytical precision.';
    return '';
  }
  const getStarterContent1 = () => {
    if (highestStarter.includes('heart')) {
      return (
        <span>
          This quadrant describes the{' '}
          <span style={{ fontStyle: 'italic' }}>emotive center</span> of our being—where we feel, value, will, and connect with others. It is here that we discover our identity, desires, and relationships
        </span>
      );
    }
    if (highestStarter.includes('str')) {
      return (
        <span>
          This quadrant represents the{' '}
          <span style={{ fontStyle: 'italic' }}>sensory center</span> of our being—the part that absorbs tactile data and converts it into action.
        </span>
      );
    }
    if (highestStarter.includes('soul')) {
      return (
        <span>
          This quadrant represents the{' '}
          <span style={{ fontStyle: 'italic' }}>meaning center</span> of our being—the part that seeks to understand our lives, stories, and purpose in the world.
        </span>
      );
    }
    if (highestStarter.includes('mind')) {
      return (
        <span>
          This quadrant represents the{' '}
          <span style={{ fontStyle: 'italic' }}>strategic center</span> of our being—where we organize and structure our inner and outer worlds into intelligible systems.
        </span>
      );
    }
    return '';
  };
  const getStarterContent2 = () => {
    if (highestStarter.includes('heart')) {
      return (
        <span>
          From this inner space, we build social constructs, find our tribe, and build a life with and for others. This quadrant answers the core question of{' '}
          <span style={{ fontStyle: 'italic' }}>Who.</span>
        </span>
      );
    }
    if (highestStarter.includes('str')) {
      return (
        <span>
          From this space, we experience and engage with the physical world, gathering resources and adopting behaviors to achieve goals. This quadrant is anchored in our bodies and addresses the fundamental question of{' '}
          <span style={{ fontStyle: 'italic' }}>How.</span>
        </span>
      );
    }
    if (highestStarter.includes('soul')) {
      return (
        <span>
          From this inner space, we dream, imagine, and create, crafting a vision for our lives, families, and businesses. We then inspire ourselves and others to move toward that envisioned future. This dimension addresses the fundamental question of{' '}
          <span style={{ fontStyle: 'italic' }}>Why.</span>
        </span>
      );
    }
    if (highestStarter.includes('mind')) {
      return (
        <span>
          From this space, we seek to understand reality, creating logical connections that offer coherence and safety. We build and align ourselves with theories and truths that shape our way of being. This quadrant answers the core question of{' '}
          <span style={{ fontStyle: 'italic' }}>What.</span>
        </span>
      );
    }
    return '';
  };
  const getStarterContent3 = () => {
    if (highestStarter.includes('heart')) return 'Collaborative Leadership is the style associated with Heart.';
    if (highestStarter.includes('str')) return 'Performance Leadership is the style linked to Strength.';
    if (highestStarter.includes('soul')) return 'Visionary Leadership resonates with the essence of the Soul.';
    if (highestStarter.includes('mind')) return 'Strategic Leadership aligns with the essence of the Mind.';
    return '';
  }

  const getLeadershipHeading = () => {
    // console.log("highest leadership", highestLeadershipStarter);

    if (highestLeadershipStarter.includes('col')) return 'Collaborative Leadership';
    if (highestLeadershipStarter.includes('strat')) return 'Strategic Leadership';
    if (highestLeadershipStarter.includes('per')) return 'Performance Leadership';
    if (highestLeadershipStarter.includes('vis')) return 'Visionary Leadership';
    return '';

  }
  const getLeadershipHeadingColor = () => {
    switch (highestLeadershipStarter) {
      case 'collaborative':
        return "#B6111F"
      case 'strategic':
        return "#667F96"
      case 'performance':
        return "#C99212"
      case 'visionary':
        return "#00577D"
      default:
        return "#343232";
    }
  }


  const getLeadershipColor = () => {
    if (highestLeadershipStarter.includes('col')) return '#667F96' // Blue-gray for Collaborative
    if (highestLeadershipStarter.includes('strat')) return '#00577D' // Blue for Strategic
    if (highestLeadershipStarter.includes('per')) return '#C99212' // Gold/Yellow for Performance
    if (highestLeadershipStarter.includes('vis')) return '#B6111F' // Red for Visionary
    return '#000000' // Default black if none match
  }



  const getLeadershiplogo = () => {
    if (highestLeadershipStarter.includes('col')) return collaborativelogo
    if (highestLeadershipStarter.includes('strat')) return stratrgiclogo
    if (highestLeadershipStarter.includes('per')) return performancelogo
    if (highestLeadershipStarter.includes('vis')) return visionarylogo
    else return logo3
  }
  const getLeadershipInfo = () => {
    if (highestLeadershipStarter.includes('col')) return 'Collaborative Leaders excel in creating environments where everyone feels important and valued.'
    if (highestLeadershipStarter.includes('strat')) return 'Strategic Leaders excel at connecting big-picture goals with practical execution to achieve results.'
    if (highestLeadershipStarter.includes('per')) return 'Performance Leaders turn strategic vision into actionable steps ensuring smooth operations and notable results.'
    if (highestLeadershipStarter.includes('vis')) return 'Visionary Leaders embody wisdom and perspective, often motivated to build a lasting legacy.'
    return 'Collaborative Leaders excel in creating environments where everyone feels important and valued. '
  }

  const getLeadershipContent1 = () => {
    if (highestLeadershipStarter.includes('col')) {
      return (
        <span>Collaborative Leaders are motivated by their values and passions, focusing on building and sustaining meaningful relationships.</span>
      );
    }
    if (highestLeadershipStarter.includes('vis')) {
      return (
        <span>Visionary Leaders are motivated by the pursuit of meaning, value, and purpose within an organization.</span>
      );
    }
    if (highestLeadershipStarter.includes('strat')) {
      return (
        <span>Strategic Leaders are motivated by creating strategies and plans that establish common goals, viable structures, and align teams.</span>
      );
    }
    if (highestLeadershipStarter.includes('per')) {
      return (
        <span>Performance Leaders are motivated by achievement and delivering results.</span>
      );
    }
    return '';
  };
  const getLeadershipContent2 = () => {
    if (highestLeadershipStarter.includes('col')) {
      return (
        <span>
          They use their{' '}
          <span style={{ fontStyle: 'italic' }}>Heart Quadrant</span> to connect with people, fostering a sense of purpose and belonging.
        </span>
      );
    }
    if (highestLeadershipStarter.includes('vis')) {
      return (
        <span>
          They use their{' '}
          <span style={{ fontStyle: 'italic' }}>Soul Quadrant</span> to craft compelling visions, creative ideas, iconic brands, and core stories that inspire and give significance to people’s work.
        </span>
      );
    }
    if (highestLeadershipStarter.includes('strat')) {
      return (
        <span>
          They use their{' '}
          <span style={{ fontStyle: 'italic' }}>Mind Quadrant</span> to build conceptual frameworks that integrate policies and steward organizational assets.
        </span>
      );
    }
    if (highestLeadershipStarter.includes('per')) {
      return (
        <span>
          They use their{' '}
          <span style={{ fontStyle: 'italic' }}>Strength Quadrant</span> to execute tasks and fulfill leadership responsibilities.
        </span>
      );
    }
    return '';
  };
  const getLeadershipContent3 = () => {
    if (highestLeadershipStarter.includes('col')) return 'With emotional intelligence, natural empathy, and strong communication skills, they lead by creating circles of trust that help people bond and work together effectively.';
    if (highestLeadershipStarter.includes('vis')) return 'As visionaries, innovators, and storytellers, they offer a unique perspective and motivating rationale to help the organization achieve its mission.';
    if (highestLeadershipStarter.includes('strat')) return 'As designers, thinkers, and planners, they provide the unifying principles and processes that empower people to solve complex problems and function effectively.';
    if (highestLeadershipStarter.includes('per')) return 'As doers, managers, and drivers they channel their energy into achieving measurable and attainable goals. They have a strong desire to serve people with excellence and accountability.';
    return '';
  }


  const getFlowImage = () => {
    const images = {
      HS: flow_HS,
      HM: flow_HM,
      HST: flow_HST,
      MH: flow_MH,
      MS: flow_MS,
      MST: flow_MST,
      SH: flow_SH,
      SM: flow_SM,
      SST: flow_SST,
      STH: flow_STH,
      STM: flow_STM,
      STS: flow_STS,
    };
    const mapStarter = (starter) => {
      if (starter?.includes("str")) return "ST";
      return starter?.split("_")[0][0]?.toUpperCase();
    };

    const key = `${mapStarter(mostSelecTedStarter)}${mapStarter(secondMostSelecTedStarter)}`;
    return images[key?.toUpperCase()] || flowImage;
  };


  const flowContentMapping = {
    "Heart to Soul": [
      "Heart to Soul individuals thrive in the realms of feeling and meaning, emphasizing identity, values, and purpose over direct action.",
      "They focus on cultivating spaces where life, love, and leadership can flourish naturally.",
      "They often bring a poetic or romantic touch to their approach, valuing soulful influence over conventional methods.",
      "Discover your possible archetypes—get the complete report now!",
    ],
    "Heart to Mind": [
      "Heart to Mind individuals blend deep empathy with strategic thinking.",
      "They first care, then strategize, ensuring their plans are refined through open, relational dialogue.",
      "Their approach merges emotional intelligence with intellectual rigor, creating compassionate and effective leadership.",
      "Discover your possible archetypes—get the complete report now!",
    ],
    "Heart to Strength": [
      "Heart to Strength individuals are dynamic and action-driven.",
      "They channel their emotions and needs into powerful execution.",
      "They seamlessly transition from empathizing and connecting to actively mobilizing and achieving.",
      "Discover your possible archetypes—get the complete report now!",
    ],
    "Soul to Mind": [
      "Soul to Mind individuals start with depth, meaning, and wisdom, crafting conceptual frameworks to bring their visions to life.",
      "They attach order and structure to their inner-worlds, inventing frameworks where none exist.",
      "Though their visionary plans are profound, their theoretical roots can sometimes challenge practical implementation.",
      "Discover your possible archetypes—get the complete report now!",
    ],
    "Soul to Strength": [
      "Soul to Strength individuals transform creative insights into swift action.",
      "They often bypass the design stage to make their visionary ideas a reality.",
      "Despite potential gaps in strategy or relationships, their strong willpower and commitment often lead to impressive results.",
      "Discover your possible archetypes—get the complete report now!",
    ],
    "Soul to Heart": [
      "Soul to Heart individuals prioritize relational depth and genuine presence, effortlessly forming meaningful bonds.",
      "Their contemplative and authentic approach inspires trust and loyalty.",
      "However, they may struggle in environments that favor speed and competition over relational depth and connection.",
      "Discover your possible archetypes—get the complete report now!",
    ],
    "Mind to Strength": [
      "Mind to Strength individuals merge analytical thinking with decisive action, continuously refining their strategies for optimal results.",
      "They emphasize practical information and efficiency, striving for progress and perfection.",
      "While their straightforward approach makes their ideas clear, they may sometimes overlook creativity and the needs of others.",
      "Discover your possible archetypes—get the complete report now!",
    ],
    "Mind to Heart": [
      "Mind to Heart individuals flow from logical analysis to fostering emotional connections.",
      "These individuals seek to understand deeply before inviting others to share their vision through inclusive and thoughtful processes.",
      "Their rational approach can provide direction, uniting people with a well-established plan.",
      "Discover your possible archetypes—get the complete report now!",
    ],
    "Mind to Soul": [
      "Mind to Soul individuals begin with a clear plan and then delve into its broader significance.",
      "They commit to projects that resonate with their logical understanding and personal values ensuring both success and fulfillment.",
      "However, they may face challenges translating their profound insights into concrete actions.",
      "Discover your possible archetypes—get the complete report now!",
    ],
    "Strength to Heart": [
      "Strength to Heart individuals launch their missions with enthusiasm and a welcoming spirit, effortlessly drawing others in.",
      "Their natural motivation and genuine empathy fuel both the start and ongoing momentum of projects.",
      "While their drive for success builds strong initial connections, shifting goals or plans can strain these relationships.",
      "Discover your possible archetypes—get the complete report now!",
    ],
    "Strength to Soul": [
      "Strength to Soul individuals are dynamic visionaries who seek meaning in their work, blending personal values with professional goals.",
      "They balance practical actions with broader visions, inspiring others by showing how success can align with purpose.",
      "However, their high standards and shift from straightforward tasks to purpose-driven objectives may alienate teammates used to direct methods.",
      "Discover your possible archetypes—get the complete report now!",
    ],
    "Strength to Mind": [
      "Strength to Mind individuals drive progress with a relentless focus on improving and strategizing.",
      "Their pursuit of efficiency propels them forward toward success in various areas of their life.",
      "However, they may overlook certain aspects of their environment, prioritizing action and strategy over relationships and understanding.",
      "Discover your possible archetypes—get the complete report now!",
    ]
  };


  const getFlowHead = () => {

    const flowMapping = {
      HS: "Heart to Soul",
      HM: "Heart to Mind",
      HST: "Heart to Strength",
      MH: "Mind to Heart",
      MS: "Mind to Soul",
      MST: "Mind to Strength",
      SH: "Soul to Heart",
      SM: "Soul to Mind",
      SST: "Soul to Strength",
      STH: "Strength to Heart",
      STM: "Strength to Mind",
      STS: "Strength to Soul",
    };


    const mapStarter = (starter) => {
      if (starter?.includes("str")) return "ST";
      return starter?.split("_")[0][0]?.toUpperCase();
    };

    const key = `${mapStarter(mostSelecTedStarter)}${mapStarter(secondMostSelecTedStarter)}`;
    const flowText = flowMapping[key] || "";
    return flowText;

  };

  const getFlowTagline = {
    "Heart to Soul": ["Feels good. But why?"],
    "Heart to Mind": ["Feels good; I need to understand."],
    "Heart to Strength": ["Feels good. Let’s go!"],
    "Mind to Heart": ["Makes sense, who do I need?"],
    "Mind to Soul": ["Makes sense, but why?"],
    "Mind to Strength": ["Makes sense; let’s go!"],
    "Soul to Heart": ["This is meaningful; let’s feel it."],
    "Soul to Mind": ["This is meaningful; let’s design it."],
    "Soul to Strength": ["This is meaningful; let’s do something."],
    "Strength to Heart": ["I’m doing this. Who’s in?"],
    "Strength to Mind": ["I’m doing this. How can it be better?"],
    "Strength to Soul": ["I’m doing this, but why?"],
  };

  const getFlowSubHeading = () => {

    const flowMapping = {
      HS: "These individuals focus on feeling and meaning, prioritizing internal experiences over external actions.",
      HM: "These individuals integrate empathy with strategy, creating compassionate and well-informed plans.",
      HST: "These individuals channel their deep feelings into dynamic action, shifting from empathy to execution.",
      MH: "These individuals blend logic with emotional connection, crafting inclusive and thoughtful pathways forward.",
      MS: "These individuals align plans with personal values, merging insightful vision with meaningful action.",
      MST: "These individuals blend analytical insight with action to achieve efficient and improved outcomes.",
      SH: "These individuals foster deep connections and inspire trust with their thoughtful, genuine presence. ",
      SM: "These individuals transform wisdom and vision into frameworks, giving structure to their deep insights.",
      SST: "These individuals turn insights into immediate action, harnessing deep creativity for remarkable outcomes.",
      STH: "These individuals motivate with enthusiasm and empathy, forging connections that thrive on shared goals.",
      STM: "These individuals inspire others by showing how work can be both successful and deeply transformative. ",
      STS: "These individuals channel relentless drive and strategic insight to continually enhance and excel.",
    };


    const mapStarter = (starter) => {
      if (starter?.includes("str")) return "ST";
      return starter?.split("_")[0][0]?.toUpperCase();
    };

    const key = `${mapStarter(mostSelecTedStarter)}${mapStarter(secondMostSelecTedStarter)}`;

    const flowText = flowMapping[key] || "";
    return flowText;
  };

  const getMindSetContent = () => {
    const score = getMindsetSum(apiData?.variables);

    const percentage = getPercentileFromScore(score)
    const mindsetCategory = capitalize(categorizeMindset(Math.round(percentage)));
    const isGrowthMindset = mindsetCategory === "Growth";
    const isConditionalMindset = mindsetCategory === "Conditional";


    return (
      <>
        <div className="logo">
          <img
            src={
              isGrowthMindset
                ? Leaf
                : isConditionalMindset
                  ? conditionalLogo2
                  : FixedMindsetLogo
            }
            alt="logo"
          />
        </div>
        <div className="heading">
          <p className="subheading">
            You lean towards a{" "}
            <span style={{ display: "block" }}>
              {isGrowthMindset
                ? "Growth Mindset."
                : isConditionalMindset
                  ? "Conditional Mindset."
                  : "Fixed Mindset."}
            </span>
          </p>
        </div>
        <div className="info">
          <p>
            {isGrowthMindset
              ? "Growth mindset individuals see effort, learning, and persistence as keys to developing their abilities and intelligence."
              : isConditionalMindset
                ? "A mixed mindset sees growth as possible in areas of strength, valuing effort for success but avoiding uncertain risks."
                : "Fixed mindset individuals believe that abilities and intelligence are relatively static and challenging to change."}
          </p>
        </div>
      </>
    );
  };

  const StatsContainer = () => {
    const score = getMindsetSum(apiData?.variables);
    const percentage = getPercentileFromScore(score)
    const mindsetCategory = capitalize(categorizeMindset(Math.round(percentage)));

    const isGrowthMindset = mindsetCategory === "Growth";
    const isConditionalMindset = mindsetCategory === "Conditional";
    const isFixedMindset = mindsetCategory === "Fixed"

    const descriptionText = isGrowthMindset
      ? [
        "Having a growth mindset means believing that your abilities and intelligence can be developed through effort, learning, and persistence.",
        "This perspective embraces challenges as opportunities for growth and views failures as steps toward mastery. Individuals with a growth mindset thrive on learning and resilience, fostering continuous improvement and innovation.",
        "By valuing feedback and finding inspiration in others' successes, they create supportive environments where everyone can excel. Embracing a growth mindset leads to higher levels of achievement and a commitment to lifelong learning and development.",
      ]
      : isConditionalMindset
        ? [
          "You have a mixed mindset, believing growth is achievable, especially where you're naturally confident or skilled.",
          "While you value effort, it's often linked to success rather than the process of learning itself. You're comfortable with challenges that align with your strengths but may hesitate to step outside your comfort zone.",
          "To grow further, start viewing effort as essential to development and seek feedback that encourages improvement. By embracing challenges and focusing on progress, you’ll unlock greater opportunities for personal growth and success.",
        ]
        : [
          "Having a fixed mindset means believing that your abilities and intelligence are relatively static and challenging to change.",
          "While this perspective can sometimes lead to avoiding challenges or feeling discouraged by setbacks, recognizing this mindset is the first step toward growth. By gradually embracing challenges and seeking constructive feedback, individuals can shift toward a more adaptive outlook.",
          "Small steps towards a growth mindset can lead to significant personal and professional improvements, fostering resilience, adaptability, and a greater sense of fulfillment.",
        ];

    return (
      <div className="stats-container">
        <div className="section-1-mind">
          {windowWidth > 600 && (
            <h2>
              {/* {`${leader !== null ? member + ',' : selfUserName !== null ? selfUserName.split(" ")[0] + ',' : ''} ${leader !== null || selfUserName !== null ? 'you' : 'You'} have a`}{" "} <br />
              <span style={{ color: (isConditionalMindset || isFixedMindset) ? "#00577D" : "#008000" }}>
                {isGrowthMindset
                  ? "Growth Mindset."
                  : isConditionalMindset
                    ? "Conditional Mindset."
                    : "Fixed Mindset."}
              </span> */}

              <p style={{ margin: 0, marginBottom: '8px' }}>{firstName}{firstName ? ', you' : 'You'} lean towards
                <br />
                a {" "} <span style={{ color: (isConditionalMindset || isFixedMindset) ? "#00577D" : "#008000" }}>
                  {isGrowthMindset
                    ? "Growth Mindset."
                    : isConditionalMindset
                      ? "Conditional Mindset."
                      : "Fixed Mindset."}
                </span>
              </p>
            </h2>
          )}
          <img src={isGrowthMindset ? Leaf : isConditionalMindset ? conditionalLogo2 : isFixedMindset ? FixedMindsetLogo : Leaf} alt="Mindset Image" className="mindset-img" />
          {windowWidth <= 600 && (
            <h2>
              {/* You have a{" "} <br />
              <span style={{ color: "#00577D" }}>
                {isGrowthMindset
                  ? "Growth Mindset."
                  : isConditionalMindset
                    ? "Conditional Mindset."
                    : "Fixed Mindset."}
              </span> */}

              <p style={{ margin: 0 }}>{firstName}{firstName ? ', you' : 'You'} lean towards a </p>
              {/* {firstName}, you lean towards a   */}
              <span style={{ color: "#00577D", display: 'block', marginTop: '10px', fontSize: 'inherit' }}>
                {isGrowthMindset
                  ? "Growth Mindset."
                  : isConditionalMindset
                    ? "Conditional Mindset."
                    : "Fixed Mindset."}
              </span>
            </h2>
          )}
        </div>

        <div className="section-2-mind">
          <div className="content-2">
            {descriptionText.map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>
        </div>
      </div>
    );
  };



  if (isLoading) {
    return (
      <div className="result-container results loading">
        <CircularProgress style={{ color: "#00577D" }} size={60} />
      </div>
    );
  }

  return (
    <>
      <div className="result-container results">
        <div className="details-container">
          {/* {showTitleText()} */}
          <div className="headline">
            <h1>Your SNAPSHOT RESULTS</h1>
            <p className="subtext">
              Your Quadrant Flow offers a structured personality analysis through standardized testing, guiding your decisions, career planning, and personal growth.{" "}
            </p>
          </div>
          {/* <div className="progress-bar">
            <div className="si_ass_result">
              <div className="si_ass_progress">
                <div className="transparent" style={{width: `${100-(Math.round(score))}%`}}></div> */}
          {/* <div className="progress-line" style={{ left: Math.round(score) + '%' }}>
                    <div className="progress-text" style={ windowWidth < 651 && score < 30 ? { left: '-50px', width: '10ch', top: '-85px' } : getBarTextLeft(score)}>{showProgressBarText(score)}</div>
                </div> */}
          {/* <span className="msi_score" style={getLeftMargin()}>{Math.round(score)}%</span>
                <div className="score-arrow" style={{ left: Math.round(score) + '%' }}></div>
              </div>
              <div className="pervalue">
                <h4 className="nimp1" style={{ minWidth: '0%' }}></h4>
                <h4 className="nimp" style={{ minWidth: '50%' }}></h4>
                <h4 className="mexpe" style={{ minWidth: '30%' }}></h4>
                <h4 className="eexpe" style={{ minWidth: '20%' }}></h4> */}
          {/* <h4 className="eexpe1" style={{ minWidth: '20%' }}></h4> */}
          {/* <h4 className="eexpe2" style={{ minWidth: '18%' }}></h4> */}
          {/* <h4 className="vexpe" style={{ minWidth: '5%' }}></h4> */}
          {/* </div>

              <div className="si_pro_header">
                <h4 className="nimp" style={{ minWidth: '0%' }}></h4>
                <h4 className="mexpe" style={{ minWidth: '50%' }}></h4>
                <h4 className="eexpe" style={{ minWidth: '30%' }}></h4> */}
          {/* <h4 className="eexpe1" style={{ minWidth: '30%' }}></h4> */}
          {/* <h4 className="eexpe" style={{ minWidth: '30%' }}></h4> */}
          {/* </div> */}

          {/* <div className="pervalue-text"> */}
          {/* <h4 className="nimp" style={{ minWidth: '45%',  }}></h4> */}
          {/* <h4 className="mexpe" style={{ minWidth: '25%',  }}></h4> */}
          {/* <h4 className="eexpe" style={{ minWidth: '30%', f }}></h4> */}
          {/* <h4 className="vexpe" style={{ minWidth: '5%' }}></h4> */}
          {/* </div> */}

          {/* <div className="pervalue-text">
                <p className="not-aligned" style={{ width: "50%", fontWeight: score <= 50 ? 700 : 400 }}>Less<br />Effective</p> */}
          {/* <p className="poor-aligned" style={{ marginLeft: '25%', fontWeight: score > 20 && score <= 40 ? 800 : 600 }}>Poorly<br />Aligned</p> */}
          {/* <p className="some-aligned" style={{ width: "30%", fontWeight: score > 50 && score <= 80 ? 700 : 400 }}>Somewhat<br />Effective</p> */}
          {/* <p className="well-aligned" style={{ marginLeft: '65%', fontWeight: score > 60 && score <= 80 ? 800 : 600 }}>Well<br />Aligned</p> */}
          {/* <p className="high-aligned" style={{ width: "20%", fontWeight: score > 80 ? 700 : 400 }}>Highly<br />Effective</p>
              </div>

            </div>
          </div> */}
          {/* <div className="spacer"></div>
          <div className="spacer"></div> */}

          {/* {showScoreText()} */}
          {/* <h3 className="pre-score-header">{name}, your overall score is <b>{Math.round(score)}%</b>. Below are your scores per category.</h3> */}
          {/* <div className="score-section-container">

            {sectionsAndSubScores?.map(sec => {
              return (
                <div key={sec.section} className="score-section">
                  <p className="score-name">{sec.section}</p>
                  <p className="score-txt" style={{
                      // marginLeft: `calc(${parseInt(sec.score)}% - 3ch)` 
                  }}>{Math.round(sec.score)}%</p>
                  <div className="score-slider"><LinearProgress className="custom-bar" variant="determinate" value={Math.round(sec?.score)} />
                  </div>
                </div>)
              })}
          </div> */}

          {/* <ClickableCircularProgressBars sectionsAndSubScores={sectionsAndSubScores} sortedSectionsAndSubScores={sortedSectionsAndSubScores} /> */}
          <div className="assessments-type-container">
            <div className="cards">
              <div className="card-1">
                <div className="card">
                  <div className="title">
                    <p>Starter</p>
                  </div>
                  <div className="logo">
                    <img src={getStarterLogo()} alt="Starter Logo" />
                  </div>
                  <div className="heading">
                    <p className="subheading">{getSubheading()}</p>
                  </div>
                  <div className="info">
                    <p>{getSubheadingInfo()}</p>
                  </div>
                </div>
                <div className="card">
                  <div className="title">
                    <p>Flow</p>
                  </div>
                  <div className="logo">
                    <img src={getFlowImage()} alt="logos" />
                  </div>
                  <div className="heading">
                    <p className="subheading">You flow from {getFlowHead()}.</p>
                  </div>
                  <div className="info">
                    <p>
                      {getFlowSubHeading()}
                    </p>
                  </div>
                </div>
              </div>
              <div className="card-2">
                <div className="card">
                  <div className="title leadership-heading">
                    <p>Leadership</p>
                  </div>
                  <div className="logo">
                    <img src={getLeadershiplogo()} alt="logo" />
                  </div>
                  <div className="heading">
                    <p className="subheading">
                      You reflect a
                      <br />
                      {getLeadershipHeading()} style.
                      {/* <span style={{ display: 'block' }}> style.</span> */}
                    </p>
                  </div>
                  <div className="info">
                    <p>{getLeadershipInfo()}</p>
                  </div>
                </div>
                <div className="card">
                  <div className="title mindset-heading">
                    <p>Mindset</p>
                  </div>
                  {getMindSetContent()}
                </div>
              </div>
            </div>
          </div>

          {/*  <div className="note">
            <p>👉<strong>Note:</strong> This is just a summary of your results. For the full report please contact your consultant.</p>
          </div> */}

          <div className="scroll-down">
            <p>Scroll to learn more about your results</p>
            <img src={arrowDown} alt="" />
          </div>

          {/* <div className="charts-accordions-container">
            {chartsData?.map((chart, idx) => {
              return (<Accordion defaultExpanded={idx === 0 ? true : false}>
                <AccordionSummary expandIcon={<CustomExpandIcon />}>
                  <p>{chart?.title}</p>
                </AccordionSummary>
                <AccordionDetails>
                  <DonutChartAccordion answer={chart.answer} data={chart.values} order={chart.order} dashboard={false} />
                </AccordionDetails>
              </Accordion>);
              })
            }
          </div> */}
        </div>
      </div>
      <div className="result-container results-2">
        {windowWidth >= 550 && (
          <div
            style={{
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <Stack
              direction={"row"}
              sx={{
                overflowY: "auto",
                height: "70px",
                flexDirection: "row",
                background: "#144B65",
                borderRadius: "50px",
                gap: "10px",
                marginTop: "50px",
                marginBottom: "50px",
              }}
            >
              {categories.map((category, index) => (
                <button
                  key={index}
                  onClick={() => {
                    setSelectedCategory(category);
                    setSelectedCategoryIdx(categories.indexOf(category));
                  }}
                  className="category-btn"
                  style={{
                    background:
                      category === selectedCategory ? "#BF9540" : "#144B65",
                    color: "white",
                    borderRadius: "50px",
                    width: "218px",
                    fontWeight: category === selectedCategory ? "700" : "400",
                    fontSize: "24px",
                    border: "none",
                    lineHeight: "38px",
                    cursor: "pointer",
                    fontFamily: '"Lato", sans-serif;'
                  }}
                >
                  <span className="tab-item"
                    style={{
                      opacity: category === selectedCategory ? "1" : "0.8",
                    }}
                  >
                    {category}
                  </span>
                </button>
              ))}
            </Stack>
          </div>
        )}
        {windowWidth < 550 && (
          <div
            style={{
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              display: "flex",
              marginTop: "30px",
              marginBottom: "30px",
              paddingTop: "10px",
            }}
          >
            <IconButton
              onClick={handleSetCategoryLeft}
              sx={{
                backgroundColor: "#BF9540",
                marginLeft: "20px",
                width: "40px",
                borderRadius: "0px",
                height: "40px",
                color: "white",
                "&:hover": {
                  backgroundColor: "#BF9540",
                },
                "&:active": {
                  backgroundColor: "#BF9540",
                },
                "&:focus": {
                  backgroundColor: "#BF9540",
                },
              }}
            >
              <ArrowLeftIcon sx={{ fontSize: 50 }} />
            </IconButton>
            <span
              style={{
                fontFamily: "Lato, sans-serif",
                fontSize: "21px",
                fontWeight: "700",
                lineHeight: "25.2px",
                textAlign: "center",
                color: "#ffffff",
              }}
            >
              {selectedCategory}
            </span>
            <IconButton
              onClick={handleSetCategoryRight}
              sx={{
                backgroundColor: "#BF9540",
                marginRight: "20px",
                width: "40px",
                borderRadius: "0px",
                height: "40px",
                color: "white",
                "&:hover": {
                  backgroundColor: "#BF9540",
                },
                "&:active": {
                  backgroundColor: "#BF9540",
                },
                "&:focus": {
                  backgroundColor: "#BF9540",
                },
              }}
            >
              <ArrowRightIcon sx={{ fontSize: 50 }} />
            </IconButton>
          </div>
        )}

        {selectedCategory === categories[0] && (
          <div className={`details-container-2 ${selectedCategory}`}>
            <div className="stats-container starter">
              <div className="section-1">
                {windowWidth > 600 && (<h2>
                  {/* {`${leader !== null  ? member : selfUserName !== null  ? selfUserName.split(" ")[0] + ',' : '' } ${leader !== null || selfUserName !== null ? 'you' : 'You'} are a`} {" "} */}
                  {/* <span style={{ color: "#B6111F" }}>{getBottomHeading()}</span> */}
                  {firstName ? `${firstName}, you show up as a ` : `You show up as a `} <br /> <span style={{ color: color }}>{text}</span>
                  {/* <span style={{ color: color }}>{text}</span> */}
                </h2>)}
                <div className="chart">
                  {/* <PolarAreaChart
                    originalData={snapshotResult}
                    labels={starterLabel}
                    ch='mind'
                  /> */}
                  <StarterChart
                    originalData={snapshotResult}
                    labels={starterLabel}
                    ch='mind'
                  />
                </div>
                {windowWidth < 600 && (<h2>
                  {/* You are a {" "}
                  <span style={{ color: color }}>{text}</span> */}
                  {firstName ? `${firstName}, you show up as a ` : `You show up as a `} <br /> <span style={{ color: color }}>{text}</span>
                </h2>)}
              </div>
              <div className="section-2">
                <div className="content-2">
                  {/*  <h2>
                    John, you tested as a{" "} <br />
                    <span style={{ color: "#B6111F" }}>Heart Starter</span>!
                  </h2> */}
                  <p>
                    {getStarterContent1()}
                  </p>
                  <p>
                    {getStarterContent2()}
                  </p>
                  <p>
                    {getStarterContent3()}
                  </p>
                  <p className="bottomtext">
                    {" "}
                    Uncover your strengths and growth opportunities—get the full
                    report now!
                  </p>
                  {/* <p>
                    <span style={{ fontWeight: 700 }}>Heart Starters</span> are
                    connection-orientated people who may lead with feelings, wants,
                    passion, or desires.</p>
                  <p> They are often motivated by the need to belong, which pushes them
                    toward a deeper relationship with themselves and others. Capacity
                for connection as the fundamental point for action.</p> */}
                </div>
              </div>
            </div>
            {/* <div className="info-container">
              <div className="info-section-1">
                <img src="https://i.ibb.co/Q8f55yT/Quadrant-Flow-Icons-1.png" />
                <p>Heart-Starters often ask:</p>
                <ul>
                  <li>Who will do it?</li>
                  <li>Who is with me?</li>
                  <li>Who do I need?</li>
                  <li>Who will this help?</li>
                </ul>
              </div>
              <div className="info-section-2">
                {windowWidth < 550 && <div className="divider" ></div>}
                <div className="info-card">
                  <h3>At their Best:</h3>
                  <p>
                    Heart-Starters lean into their lives in order to connect with
                    people, feelings, wants, and desires. They seek to commune and
                    share their lives with others out of a strong motivation to
                    belong. Heart-Starters may bring the passionate call for others to
                    gather, join, or collaborate. Anchored in “being” rather than
                    “doing,” they have this knack for recognizing and elevating
                    someone's worth beyond their output or what they can offer.
                  </p>
                </div>
                <div className="info-card">
                  <h3>At their Worst:</h3>
                  <p>
                    Heart-Starters may become overly attached to their feelings, seek
                    to please others at the expense of their own mission, or become
                    mired in introspection and inactivity.
                  </p>
                </div>
              </div>
              </div> */}
          </div>
        )}
        {selectedCategory === categories[1] && (
          <div className={`details-container-2 ${selectedCategory}`}>
            <div className="stats-container">
              <div className="section-1-flow">
                {windowWidth > 600 && (<h2>{getFlowHead()?.toUpperCase()}<br />{getFlowTagline[getFlowHead()]?.map((line, index) => <span key={index}>{line}</span>)}</h2>)}
                <img src={getFlowImage()} alt="Image" className="flow-img" />
                {windowWidth < 600 && (<h2>{getFlowHead()?.toUpperCase()}<br />{getFlowTagline[getFlowHead()]?.map((line, index) => <span key={index}>{line}</span>)}</h2>)}
              </div>
              <div className="section-2-flow">
                <div className="content-2">
                  {flowContentMapping[getFlowHead()]?.map((line, index) => (
                    <p key={index}>{line}</p>
                  ))}
                </div>
              </div>
            </div>
            {/* <div className="info-container-flow">
              <h3>POSSIBLE ARECHETYPES</h3>
              <div className="info-list">
                <ul>
                  <li>Impractical Feeder</li>
                  <li>Complicated Connector</li>
                </ul>
                <ul>
                  <li>Idealistic Dreamer</li>
                  <li>Deep Connector </li>
                </ul>
                <ul>
                  <li>Authentic Sage </li>
                  <li>Qualitative Advocate </li>
                </ul>
              </div>
         </div> */}
          </div>
        )}
        {selectedCategory === categories[2] && (
          <div className={`details-container-2 ${selectedCategory}`}>
            <div className="stats-container">
              <div className="section-1-flow">
                {windowWidth > 600 && (<h2>
                  {/* {`${leader !== null ? member + ',' : selfUserName !== null ? capitalize(selfUserName.split(" ")[0]) + ',' : ''} ${leader !== null || selfUserName !== null ? 'you' : 'Your'} are a`}{" "}<br /><span style={{ color: `${getLeadershipHeadingColor()}` }}>{getLeadershipHeading()} Leader.</span> */}
                  {firstName}{firstName ? ", you" : "You"} reflect a {""}
                  <span style={{ color: `${getLeadershipHeadingColor()}` }}>{getLeadershipHeading()}</span> style.
                </h2>)}
                <div className="chart">
                  {/* <PolarAreaChart
                    originalData={leadershipSnapshotResults}
                    labels={leadershipLabels}
                    ch='strategic'
                    position='center'
                  /> */}
                  <StarterChart
                    originalData={leadershipSnapshotResults}
                    labels={leadershipLabels}
                    ch='mind'
                  />
                </div>
                {windowWidth < 600 && (<h2>
                  {/* {`${leader !== null ? member + ',' : selfUserName !== null ? capitalize(selfUserName.split(" ")[0]) + ',' : ''} ${leader !== null || selfUserName !== null ? 'you' : 'Your'}  are a`}{" "}<span style={{ color: `${getLeadershipHeadingColor()}` }}>{getLeadershipHeading()} Leader.</span> */}
                  {firstName}{firstName ? ", you" : "You"} reflect a {""}
                  {
                    windowWidth < 650 && <br />
                  }
                  <span style={{ color: `${getLeadershipHeadingColor()}` }}>{getLeadershipHeading()}</span> style.

                </h2>)}
              </div>
              <div className="section-2-flow">
                <div className="content-2">
                  <p>
                    {getLeadershipContent1()}
                  </p>
                  <p>
                    {getLeadershipContent2()}
                  </p>
                  <p>
                    {getLeadershipContent3()}
                  </p>
                  <p>
                    Unlock your leadership style—reveal key contributions and
                    challenges with our full report!
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="info-container-leadership">
              <div className="section-1">
                <h3>Contributions:</h3>
                <p>
                  <span>1. Clear Direction: </span> {windowWidth < 550 && <br />}Strategic leaders provide a defined
                  vision and direction, ensuring all team members understand their
                  roles in achieving organizational goals.
                  <br />
                  <span>2. Effective Planning:</span>{windowWidth < 550 && <br />} They excel in creating detailed,
                  actionable plans that simplify complex goals, enhancing efficiency
                  toward achieving organizational objectives.
                  <br />
                  <span>3. Risk Management:</span>{windowWidth < 550 && <br />} Proactively identifying and
                  mitigating potential risks to protect the organization against
                  financial, reputational, and operational setbacks.
                </p>
              </div>
              {windowWidth < 550 && <div className="divider" />}
              <div className="section-2">
                <h3>Challenges:</h3>
                <p>
                  <span>1. Overemphasis on Control:</span>{windowWidth < 550 && <br />} They may micromanage or
                  exert excessive control, potentially stifling creativity and
                  autonomy among team members, which dampens motivation & innovation.
                  <br />
                  <span>2. Resistance to Feedback:</span>{windowWidth < 550 && <br />} Some may resist feedback
                  that challenges their vision or strategies, missing critical
                  insights that could enhance outcomes.
                  <br />
                  <span>3. Neglect Qualitative Leadership:</span>{windowWidth < 550 && <br />} Focusing heavily on
                  strategic goals may lead them to overlook the importance of employee
                  morale and workplace culture.
                </p>
              </div>
       </div> */}
          </div>
        )}
        {selectedCategory === categories[3] && (
          <div className={`details-container-2 ${selectedCategory}`}>
            {StatsContainer()}
            {/* <div className="info-container-mindset">
              <div className="list-container">
                <div className="list">
                  <h4>Challenges</h4>
                  <p>I avoid challenges to minimize complexity.</p>
                </div>
                <div className="list">
                  <h4>Obstacles</h4>
                  <p>I avoid challenges to minimize complexity.</p>
                </div>
                <div className="list">
                  <h4>Effort</h4>
                  <p>I avoid challenges to minimize complexity.</p>
                </div>
                <div className="list">
                  <h4>Feedback</h4>
                  <p>I avoid challenges to minimize complexity.</p>
                </div>
                <div className="list">
                  <h4>Success of others</h4>
                  <p>I avoid challenges to minimize complexity.</p>
                </div>
              </div>
            </div> */}
          </div>
        )}
        <div className="note2">
          <p className="Note">
            👉 <strong>Note:</strong> This is just a summary of your results. For
            the full report please contact your consultant.
          </p>
        </div>
        <div className="footer-buttons">
          {selectedCategoryIdx > 0 && (
            <div className="left-button-container">
              <div className="left-button">
                <IconButton
                  onClick={handleSetCategoryLeft}
                  sx={{
                    backgroundColor: "#BF9540",
                    marginLeft: "20px",
                    width: "50px",
                    height: "50px",
                    margin: "0px",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#BF9540",
                    },
                    "&:active": {
                      backgroundColor: "#BF9540",
                    },
                    "&:focus": {
                      backgroundColor: "#BF9540",
                    },
                  }}
                >
                  {" "}
                  <ArrowBackIcon />
                </IconButton>
                <p>{categories1[selectedCategoryIdx - 1].description}</p>
              </div>
            </div>
          )}
          {selectedCategoryIdx + 1 < categories1.length && (
            <div className="right-button-container">
              <div className="right-button">
                <p>{categories1[selectedCategoryIdx + 1].description}</p>
                <IconButton
                  onClick={handleSetCategoryRight}
                  sx={{
                    backgroundColor: "#BF9540",
                    marginLeft: "20px",
                    width: "50px",
                    height: "50px",
                    margin: "0px",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#BF9540",
                    },
                    "&:active": {
                      backgroundColor: "#BF9540",
                    },
                    "&:focus": {
                      backgroundColor: "#BF9540",
                    },
                  }}
                >
                  {" "}
                  <ArrowForwardIcon />
                </IconButton>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* <Invite /> */}

      {/*  {showTeamMember()}

      {showLegacyInvite()}

      {!isMember && showDashboard()}

      {showInvite()}

            {showTestimonial()} */}

      {/* {showCallInfo()} */}

      {/* <Testimonial /> */}

      {/* <div className="testimonial-container">

        <div className="testimonial">

          <div className="testi">
            <span className="quotation-mark">“</span>Doing this assessment as a team gave us better insights into our level of alignment with our school board. It also helped us put a plan in place to make our meetings more productive, so that we continue to align on the board's objectives together.<span className="quotation-mark bottom"><div className="quotation-block">“</div></span>
          </div>

          <div className="avatar">
            <img src={testimonialImage} />
          </div>

          <div className="designation">
            Sam Davis<br />
            <span>Lead Pastor, Springs of Life Church</span>
          </div>

        </div>

      </div> */}

      {/* {showSchedule()} */}

      {/* {showLegacyInvite()} */}

      {/* </div> */}
    </>
  );
};

export default Results;
